import type {
  AuthTokenData,
  RefreshTokenData,
  UserValidation,
} from './sessionAPI';

const AUTH_TOKEN = 'auth_token';
const PRODUCTION_UNIT = 'production_unit';
const USER_ACCESS_PROFILE = 'user_access_profile';

const appLocalStorage = {
  getTokenData: (): AuthTokenData | null => {
    const authToken = window.localStorage.getItem(AUTH_TOKEN);
    if (!authToken) return null;
    return JSON.parse(authToken);
  },
  setTokenData: (data: AuthTokenData | RefreshTokenData): void => {
    window.localStorage.setItem(AUTH_TOKEN, JSON.stringify(data));
  },
  cleanTokenData: (): void => {
    window.localStorage.removeItem(AUTH_TOKEN);
  },
  getAuthToken: (): string | null => {
    const tokenData = appLocalStorage.getTokenData();
    return tokenData ? tokenData.id_token : null;
  },
  getProductionUnit: (): string | null => {
    const productionUnit = window.localStorage.getItem(PRODUCTION_UNIT);
    if (!productionUnit) return null;
    return productionUnit;
  },
  setProductionUnit: (data: string): void => {
    window.localStorage.setItem(PRODUCTION_UNIT, data);
  },
  cleanProductionUnit: (): void => {
    window.localStorage.removeItem(PRODUCTION_UNIT);
  },
  getUserAccessProfile: (): UserValidation | null => {
    const userAccessProfile = window.localStorage.getItem(USER_ACCESS_PROFILE);
    if (!userAccessProfile) return null;
    return JSON.parse(userAccessProfile);
  },
  setAccessUserProfile: (data: UserValidation): void => {
    window.localStorage.setItem(USER_ACCESS_PROFILE, JSON.stringify(data));
  },
  cleanAccessUserProfile: (): void => {
    window.localStorage.removeItem(USER_ACCESS_PROFILE);
  },
  clearLocalStorage: (): void => {
    window.localStorage.clear();
  },
};

export default appLocalStorage;
